module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('form', [_c('website', {
    ref: "website"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "p-fluid  p-col-6 p-offset-3"
  }, [_c('div', {
    staticClass: "p-field"
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "firstname",
      "type": "text"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field "
  }, [_c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "lastname",
      "type": "text"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field "
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "email",
      "type": "text"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field "
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "password",
      "type": "text"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center hover-line"
  }, [_c('Button', {
    staticClass: "btn",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "label": "CREATE"
    }
  })], 1)])]), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page section-header text-center"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CREATE ACCOUNT")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e85f48d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/UserRegister.vue
// module id = 2219
// module chunks = 0